import { render, staticRenderFns } from "./left-bottom.vue?vue&type=template&id=272daca8&"
import script from "./left-bottom.vue?vue&type=script&lang=js&"
export * from "./left-bottom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports